<template>
  <div class="p-[12px] border-[1px] border-[#E2E2E2] rounded-[12px] mb-[24px]">
    <label class="text-[#828282] block mb-[10px]">Produk Belum Termapping</label>
    <h4 class="text-[#333333] text-[14px] font-[500] mb-0">
      {{ productName }}
    </h4>
    <p class="text-[#626262] text-[12px] mb-0">
      {{ variantName }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'SyncInfoCard',
  props: {
    productName: {
      type: String,
      required: false,
      default: '-',
    },
    variantName: {
      type: String,
      required: false,
      default: '-',
    },
  },
}
</script>
